let baseAppProxy = "https://console-shopify.ringbuilder.io", shopifyFileURL = 'https://cdn.shopify.com/s/files/1/0686/8995/3069/files', errorSrc = `this.src='${shopifyFileURL}/no-image.png'`, objectProduct = {}, isFirstTime3DView = false;

const three_d_static_data = {
    pmat: {
        "14k_yellow_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_Yellow_Gold.pmat",
        "14k_white_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_White_Gold.pmat",
        "14k_rose_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_Rose_Gold.pmat",
        "18k_yellow_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_Yellow_Gold.pmat",
        "18k_white_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_White_Gold.pmat",
        "18k_rose_gold": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_Rose_Gold.pmat",
        "platinum": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/14K_White_Gold.pmat",
    },
    dmat: {
        "Pear": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Pear.dmat",
        "Marquise": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Marquise.dmat",
        "Radiant": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Radiant.dmat",
        "Emerald": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Emerald.dmat",
        "Cushion": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Cushion.dmat",
        "Oval": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Oval.dmat",
        "Round": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/DiamorsBeta/Round.dmat",
    },
    vjson: "https://all-demos.s3.amazonaws.com/3D_Assets/DiamorsBeta/Himanshu/ClairamorFinal.vjson",
};

window.variantSKUs = [];
window.RING_CREATOR_PDP = function () {
    return {
        config: {},
        fetchProductRelatedAllData: async function() {
            try {
                const productHandle = document.getElementById("setting_hdn_prod_handle").value.trim();
                var formData = new FormData();
                formData.append("action", "fetch_product_options");
                formData.append("shop", Shopify.shop);
                formData.append("handle", productHandle);
                formData.append("required_combination", true);

                const webGiProdInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
                if (webGiProdInfo?.status === "success") {
                    const webGiProdInfoData = webGiProdInfo?.data;
                    this.initEventOptionHTML(webGiProdInfoData?.option_data, webGiProdInfo?.group_id);

                    !HackWrapper.isEmpty(webGiProdInfoData?.product_data?.head_glb) && (RING_CREATOR_PDP.config.headGlbUrl = webGiProdInfoData?.product_data?.head_glb);

                    // Add product settings
                    RING_CREATOR_PDP.config.selectSettingProduct = webGiProdInfoData?.product_data ?? [];

                    // Custom Analytics || 12-11-2025
                    const productCombinationData = webGiProdInfoData?.product_combination_data ?? [];
                    if (productCombinationData?.length > 0) {
                        productCombinationData.forEach(function(item) {
                            window.variantSKUs.push({
                                id: item?.product_id ?? "",
                                title: item?.prod_title ?? "",
                                handle: item?.pro_handle ?? "",
                                variant_id: item?.variant_id ?? "",
                                variant_sku: item?.product_sku ?? "",
                                type: item?.product_type ?? "",
                                is_active: item?.pro_handle == productHandle ? true : false
                            });
                        });
                    }
                    // End || 12-11-2025
                }
            } catch (error) {
                console.log({error});
            }
        },
        initEventOptionHTML: async function (optionsData, group_id) {
            const Options = optionsData?.length > 0 ? optionsData : [], groupId = group_id;
            const productPageFilterSettingOptionsElement = document.getElementById("product-page-filter-setting-options");

            let optionHTML = "", optionDisabled = "";
            Options.forEach((key, index) => {
                const subArray = Object.values(key?.values)?.length > 0 ? Object.values(key?.values) : array();

                if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter('stone-stock'))) {
                    optionDisabled = ' disabled';
                }

                const variantOptionHtml = subArray.map((subValue) => {
                    const errorSrc = `this.src='${shopifyFileURL}/no-image.png'`;
                    // const activeClass = is_default_value === "1" ? "product-page--filter--active" : "";
                    let metalColorValue = subValue.replace(/14k|18k|14K|18K|Gold|gold/g, "").trim().toLowerCase();
                    return `<label class="clairspdp-option-item product-page--filter-value-item">
                        <input type="radio" name="${HackWrapper.handleize(key?.label)}" ${key?.selected == subValue ? `checked`: ""} data-group-id="${groupId}" data-title="${key?.label}" data-value="${subValue}">
                        ${key?.label == "Metal Type" ? `<span class="clairspdp-metal-dot ${HackWrapper.handleize(metalColorValue)}-gold"></span>` : `<span class="clairspdp-shape-icon"><img src="https://cdn.shopify.com/s/files/1/0686/8995/3069/files/${HackWrapper.handleize(subValue)}-shape.png?v=1753170626" onerror="${errorSrc}"></span>`}
                        ${subValue.replace("White/Yellow", "").trim()}
                    </label>`;
                }).join("");

                // line item property field
                optionHTML += `<div class="clairspdp-option-group">
                    <h4 class="clairspdp-option-title">${key?.label}</h4>
                    <div class="clairspdp-option-grid clairspdp-${key?.label == "Metal Type" ? `metal`:`shape`}-grid">${variantOptionHtml}</div>
                </div>`;
            });
            productPageFilterSettingOptionsElement && (productPageFilterSettingOptionsElement.innerHTML = optionHTML);
            this.initEventsOnChanged();
        },
        initEventImagesHTML: async function (imagesData) {
            const settingProductMainImage = HackWrapper.getElement('[data-setting-product-main-image]');
            const settingProductGalleryImages = HackWrapper.getElement('[data-setting-product-gallery-images]');
            const prodImageArr = imagesData || [];

            if (prodImageArr.length > 0) {
                // Render Main Image (first item)
                settingProductMainImage.innerHTML = `
                    <div class="rimage-outer-wrapper" style="max-width: 1200px">
                        <div class="rimage-wrapper" style="padding-top:100.0%">
                            <img
                                class="rimage__image fade-in lazyautosizes lazyloaded"
                                data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                                data-aspectratio="1.0"
                                data-sizes="auto"
                                alt=""
                                data-srcset="${prodImageArr[0]}"
                                sizes="1056px"
                                srcset="${prodImageArr[0]}"
                            >
                        </div>
                    </div>
                `;

                // Remove first image for gallery usage
                const galleryImages = prodImageArr.slice(1);
                
                // Render Gallery Images
                settingProductGalleryImages.innerHTML = ''; // Clear first
                let mobileGalleryHTML = '';
                for (let i = 0; i < galleryImages.length; i++) {
                    const item = galleryImages[i];
                    if (!HackWrapper.isEmpty(item)) {
                        settingProductGalleryImages.innerHTML += `
                            <div class="rimage-outer-wrapper" style="max-width: 1200px">
                                <div class="rimage-wrapper" style="padding-top:100.0%">
                                    <img
                                        class="rimage__image fade-in lazyautosizes lazyloaded"
                                        data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                                        data-aspectratio="1.0"
                                        data-sizes="auto"
                                        alt=""
                                        data-srcset="${item}"
                                        sizes="1056px"
                                        srcset="${item}"
                                    >
                                </div>
                            </div>
                        `;
                        
                        mobileGalleryHTML += `<div class="gallery-images-mobile">
                            <div class="product-media product-media--image hidden--desktop">
                                <div class="rimage-outer-wrapper" style="max-width: 2000px">
                                    <div class="rimage-wrapper " style="padding-top:95.60000000000001%">
                                        <img
                                            class="rimage__image fade-in lazyautosizes lazyloaded"
                                            data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                                            data-aspectratio="1.0460251046025104"
                                            data-sizes="auto"
                                            alt=""
                                            data-srcset="${item}"
                                            sizes="320px"
                                            srcset="${item}"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>`;
                    }
                }
                
                if (!HackWrapper.isEmpty(HackWrapper.getElement('[data-setting-product-gallery-images-mobile]')) && !HackWrapper.isEmpty(mobileGalleryHTML)) {
                    $('.clairspdp-images-mobile-slider').slick('unslick');

                    HackWrapper.getElements('.gallery-images-mobile').forEach(e => e.remove());
                    HackWrapper.getElement('[data-setting-product-gallery-images-mobile]').insertAdjacentHTML('afterend', mobileGalleryHTML);
                    $('.clairspdp-images-mobile-slider').slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true
                    });
                }
            }
        },
        initEventsOnChanged: async function () {
            if (HackWrapper.getElements('.product-page--filter-value-item input[type="radio"]')?.length > 0) {
                HackWrapper.getElements('.product-page--filter-value-item input[type="radio"]').forEach((item) => {
                    item.addEventListener("click", async function (e) {
                        let groupId = '', attributeInfo = {};
                        HackWrapper.getElements('.product-page--filter-value-item input[type="radio"]:checked').forEach((item) => {
                            attributeInfo[item.dataset.title] = item.dataset.value;
                            groupId = item.dataset.groupId;
                        });

                        try {
                            var formData = new FormData();
                            formData.append("action", "fetch_sub_options");
                            formData.append("shop", Shopify.shop);
                            formData.append("group_id", groupId.trim());
                            formData.append("attribute_info", JSON.stringify(attributeInfo));

                            const webGiProdInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
                            if (webGiProdInfo?.status === "success") {
                                const webGiProdInfoData = webGiProdInfo?.data;
                                await RING_CREATOR_PDP.initEventOptionHTML(webGiProdInfoData?.option_data, webGiProdInfoData?.product_data?.group_id);
                                await RING_CREATOR_PDP.initEventImagesHTML(webGiProdInfoData?.product_data?.images?.split(',') ?? []);

                                !HackWrapper.isEmpty(webGiProdInfoData?.product_data?.head_glb) && (RING_CREATOR_PDP.config.headGlbUrl = webGiProdInfoData?.product_data?.head_glb);

                                HackWrapper.getElements('[data-setting-product-title]').forEach(e => e.innerText = webGiProdInfoData?.product_data?.prod_title);
                                HackWrapper.getElements('[data-setting-product-type]').forEach(e => e.innerText = webGiProdInfoData?.product_data?.product_type);
                                HackWrapper.getElements('[data-setting-product-description]').forEach(e => e.innerText = webGiProdInfoData?.product_data?.description);
                                HackWrapper.getElements('[data-setting-product-price]').forEach(e => e.innerText = HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(Number(webGiProdInfoData?.product_data?.price) * 100))+' Setting Price');

                                document.getElementById("setting_hdn_prod_title").value = webGiProdInfoData?.product_data?.prod_title;
                                document.getElementById("setting_hdn_prod_id").value = webGiProdInfoData?.product_data?.product_id;
                                document.getElementById("setting_hdn_prod_handle").value = webGiProdInfoData?.product_data?.pro_handle;
                                document.getElementById("setting_hdn_prod_var_id").value = webGiProdInfoData?.product_data?.variant_id;
                                document.getElementById("setting_hdn_prod_var_price").value = webGiProdInfoData?.product_data?.price;

                                if (HackWrapper.getElement('.claird-pdp-btn.setting-product-page-btn-img-3d-action.active')?.dataset?.type == "Image") {
                                    await RING_CREATOR_PDP.handleThreeDPart(webGiProdInfoData?.product_data?.head_glb, "", true);
                                }

                                let newURL = "/collections/solitaire-engagement-rings/products/" + webGiProdInfoData?.product_data?.pro_handle+'?'; // + "?variant=" + webGiProdInfoData?.product_data?.variant_id
                                if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter('stone-stock'))) {
                                    newURL += `&stone-stock=${HackWrapper.getUrlParameter('stone-stock')}`;
                                }
                                if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter('steps'))) {
                                    newURL += `&steps=${HackWrapper.getUrlParameter('steps')}`;
                                }
                                if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter('review'))) {
                                    newURL += `&review=${HackWrapper.getUrlParameter('review')}`;
                                }
                                window.history.pushState({}, "", newURL);

                                // Update -- Custom Analytics || 12-11-2025
                                const variantSKUData = window?.variantSKUs ?? [];
                                if (variantSKUData?.length > 0) {
                                    variantSKUData.forEach(function (item, key) {
                                        window.variantSKUs[key] && (window.variantSKUs[key].is_active = webGiProdInfoData?.product_data?.pro_handle == item?.handle ? true : false);
                                    });
                                }
                                // End || 12-11-2025
                            } else {
                                console.log("Data not found based on attribute");
                            }
                        } catch (error) {
                            console.log({error});
                        }
                    });
                });
            }
        },
        matchWordFromString: function (inputString, word) {
            const regex = new RegExp(`[^a-zA-Z0-9]*(${word})[^a-zA-Z0-9]*`);
            const match = inputString.match(regex);
            if (match) {
                return match[1];
            }
            return ""; // Return empty string if the word is not found
        },
        handleThreeDPart: async function (head_glb_url, shank_glb_url, isUpdate = false) {
            // Select the metal color element
            const selectedMetalColorElement =  HackWrapper.getElement('.clairspdp-option-item.product-page--filter-value-item input[name="metal-type"]:checked'),
                selectedShapeElement =  HackWrapper.getElement('.clairspdp-option-item.product-page--filter-value-item input[name="stone-shape"]:checked');

            if (selectedMetalColorElement && selectedShapeElement) {
                // Safely retrieve and clean the metal color slug and value
                let selectedMetalColorSlug = selectedMetalColorElement?.dataset?.value?.split(" ").join("_").trim().toLowerCase() || "";
                let selectedMetalColorValue = selectedMetalColorElement?.dataset?.value?.trim() || "";
                let selectedShapValue = selectedShapeElement?.dataset?.value?.trim() || "";                

                // Handle platinum case and match the word 'platinum' if present
                if (selectedMetalColorSlug.includes("platinum")) {
                    selectedMetalColorSlug = RING_CREATOR_PDP.matchWordFromString(selectedMetalColorSlug, "platinum");
                }

                // Initialize metal head, shank, and dmat file from static data
                let metalHead = three_d_static_data["pmat"][selectedMetalColorSlug] || "";
                let metalShank = three_d_static_data["pmat"][selectedMetalColorSlug] || "";
                let dmatFile = three_d_static_data["dmat"][selectedShapValue] || "";

                // If the metal color value contains '/', it's a combination (e.g., 18k/14k gold)
                if (selectedMetalColorValue.includes("/")) {
                    // Determine the carat size (either 18k or 14k)
                    const caratSize = selectedMetalColorValue.includes("18k") ? "18k" : "14k";

                    // Split the value to get head and shank components
                    const metalParts = selectedMetalColorValue.replace(/14k|14K|18k|18K|Two Tone/g, "").trim().split("/");

                    // Construct slugs for metal head and shank
                    const selectedMetalHead = `${caratSize}_${metalParts[0]}_gold`.toLowerCase();
                    const selectedMetalShank = `${caratSize}_${metalParts[metalParts.length - 1]}_gold`.toLowerCase();

                    // Update metal head, shank, and dmat file based on the new slugs
                    metalHead = three_d_static_data["pmat"][selectedMetalHead] || "";
                    metalShank = three_d_static_data["pmat"][selectedMetalShank] || "";
                    dmatFile = three_d_static_data["dmat"][selectedShapValue] || "";
                }

                // Log the results for debugging
                console.log({selectedMetalColorSlug, metalHead, metalShank, dmatFile });

                // Generate the 3D media array using the metal head, shank, and dmat file
                const three_d_media_arr = RING_CREATOR_PDP.generateThreeDMediaArray(head_glb_url, shank_glb_url, metalHead, metalShank, dmatFile);

                // Log the 3D media array and update flag
                console.log({ three_d_media_arr, isUpdate });

                // If media array is not empty, either update or initialize the 3D player
                if (three_d_media_arr.length > 0) {
                    if (isUpdate) {
                        window.player.update("webgl_setting_canvas", three_d_media_arr);
                    } else {
                        window.player.init("webgl_setting_canvas", three_d_media_arr);
                    }
                }
            } else {
                console.error("Metal color element not found");
            }
        },
        generateThreeDMediaArray: function (head, shank = "", metal_head, metal_shank, dmat) {
            let three_d_media = [
                {
                    option_type: "model",
                    option_value: head,
                    option_identifier: "head",
                },
                {
                    option_type: "material",
                    option_value: metal_head,
                    option_identifier: "metal-head, Metal 03, metal-shank, Heads",
                },
                {
                    option_type: "material",
                    option_value: metal_shank,
                    option_identifier: "metal-shank, Metal 03",
                },
                {
                    option_type: "material",
                    option_value: dmat,
                    option_identifier: "diamond-round,diamond-round01,stone-round,stone-round1,stone-round-1,stone-round-2,stone-round-3,stone-cushion,stone-marquise,stone-pear,stone-emerald,stone-oval,stone-radiant,mainstone-cushion,mainstone-cushion.001,mainstone-marquise,mainstone-oval,mainstone-round,mainstone-radiant,mainstone-pear,mainstone-emerald,sidestone-round,sidestone-marquise,Material_3,Material_5",
                }
            ];
            if(shank){
                three_d_media.push({
                    option_type: "model",
                    option_value: shank,
                    option_identifier: "shank",
                });
            }
            console.log(three_d_media);
            return three_d_media;
        },
        loadOnClickForImages: async function(viewType) {
            const settingProductMainImage = HackWrapper.getElement('[data-setting-product-main-image]');
            const webglSettingCanvasElement = document.getElementById("webgl_setting_canvas");
                
            settingProductMainImage.style.display = "none";
            webglSettingCanvasElement.innerHTML = "";
            webglSettingCanvasElement.style.display = "none";
            if (viewType == "3D_view") {
                webglSettingCanvasElement.style.display = "block";
                await RING_CREATOR_PDP.handleThreeDPart(RING_CREATOR_PDP.config.headGlbUrl, "", isFirstTime3DView); 
                isFirstTime3DView = true;
            } else {
                settingProductMainImage.style.display = "block";    
            }
        },
        fetchStoneProductByStockNumber: async function () {
            try {
                let stockNumber = HackWrapper.getUrlParameter("stone-stock");
                if (stockNumber?.length > 0) {
                    var formData = new FormData();
                    formData.append("action", "get_stone_details");
                    formData.append("shop", Shopify.shop);
                    formData.append("labgrown_stock_num", stockNumber);

                    const getProdInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
                    if (Object.keys(getProdInfo?.data)?.length > 0) {
                        const getProdInfoData = getProdInfo?.data;
                        RING_CREATOR_PDP.config.selectStoneProduct = getProdInfoData;
                        if (HackWrapper.getUrlParameter("review") != undefined) {
                            HackWrapper.getElement("[data-review-stone-thumbnail-image] svg") && (HackWrapper.getElement("[data-review-stone-thumbnail-image] svg").classList.add('hidden'));
                            HackWrapper.getElement("[data-review-stone-thumbnail-image] img") && (HackWrapper.getElement("[data-review-stone-thumbnail-image] img").classList.remove('hidden'));
                            HackWrapper.getElement("[data-review-stone-thumbnail-image] img") && (HackWrapper.getElement("[data-review-stone-thumbnail-image] img").src = getProdInfoData?.image_url);
                            HackWrapper.getElement("[data-review-stone-thumbnail-image] img") && (HackWrapper.getElement("[data-review-stone-thumbnail-image] img").setAttribute('onerror', errorSrc));
                            HackWrapper.getElement("[data-review-stone-image]") && (HackWrapper.getElement("[data-review-stone-image]").src = getProdInfoData?.image_url);

                            const stonePrice = HackWrapper.convertToShopCurrency(Number(getProdInfoData?.total_sales_price) * 100);
                            const settingPrice = Number(HackWrapper.getElement("[data-review-total-price]").dataset.settingPrice);

                            HackWrapper.getElement("[data-review-stone-price]").innerHTML = HackWrapper.formatMoney(stonePrice);
                            HackWrapper.getElement("[data-review-total-price]").innerHTML = `${HackWrapper.formatMoney(stonePrice+settingPrice)} &nbsp; <small>Subtotal</small>`;

                            let stoneDetailHTML = "";
                            getProdInfoData?.shape && (stoneDetailHTML += `<p>Shape: ${getProdInfoData?.shape}</p>`);
                            getProdInfoData?.size && (stoneDetailHTML += `<p>Carat: ${getProdInfoData?.size}</p>`);
                            if (getProdInfoData?.is_fancy==false) {
                                getProdInfoData?.color && (stoneDetailHTML += `<p>Color: ${getProdInfoData?.color}</p>`);
                            } else {
                                stoneDetailHTML += `<p>Color: ${(getProdInfoData?.fancy_color_intensity_short || "") +" "+ (getProdInfoData?.fancy_color_overtone_short || "") +" "+ (getProdInfoData?.fancy_color_short || "")}</p>`;
                            }
                            getProdInfoData?.clarity && (stoneDetailHTML += `<p>Clarity: ${getProdInfoData?.clarity}</p>`);
                            document.querySelector("[data-review-stone-detail]").innerHTML = stoneDetailHTML;

                            let reviewSubtitleElement = HackWrapper.getElement("[data-review-subtitle]");
                            reviewSubtitleElement.innerHTML = `${getProdInfoData?.shape} Lab Diamond, ${HackWrapper.extractByDelimiter(reviewSubtitleElement.dataset.reviewSubtitle)}`;
                        }
                    }
                }
            } catch (error) {
                console.log({ error });
            }
        },
        addToCartRing: async function (_this, formData) {
            let _formData = formData;
            try {
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(_formData)
                }).then((response) => {
                    return response.json();
                }).then(async (result) => {
                    if (result?.items?.length > 0) {
                        location.href = "/cart";
                        _this.removeAttribute("disabled", "disabled");
                        _this.classList.remove("disabled");
                        _this.textContent = "Add to Bag";
                        return;
                    } else {
                        $addDiamondToCartTry++;
                        if ($addDiamondToCartTry > 5) {
                            _this.removeAttribute("disabled", "disabled");
                            _this.classList.remove("disabled");
                            _this.textContent = "Add to Bag";
                            return;
                        } else {
                            await HackWrapper.sleep(5000);
                            await window.RING_CREATOR_PDP.addToCartRing(_this, _formData);
                            return;
                        }
                    }
                })
                .catch(async (err) => {
                    $addDiamondToCartTry++;
                    if ($addDiamondToCartTry > 5) {
                        _this.removeAttribute("disabled", "disabled");
                        _this.classList.remove("disabled");
                        _this.textContent = "Add to Bag";
                        swal("Oops!", err?.message, "error");
                        return;
                    } else {
                        await HackWrapper.sleep(5000);
                        await window.RING_CREATOR_PDP.addToCartRing(_this, _formData);
                        return;
                    }
                });
            } catch (error) {
                console.log({ error: error });
            }
            _this.innerHTML = "Add to Bag";
            _this.disabled = false;
        }
    }
}();

document.addEventListener('DOMContentLoaded', async function() {
    await RING_CREATOR_PDP.fetchProductRelatedAllData();
    if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter("stone-stock"))) {
        await RING_CREATOR_PDP.fetchStoneProductByStockNumber();
    }

    if (!HackWrapper.isEmpty(HackWrapper.getCookie('ringSize'))) {
        HackWrapper.getElement('#clair-stone-view-size') && (HackWrapper.getElement('#clair-stone-view-size').value = HackWrapper.getCookie('ringSize'));

        const ringSizeElements = HackWrapper.getElements('.clairspdp-option-item.clairspdp-option-item-ring input[name="ring-size"]') ?? [];
        ringSizeElements?.length > 0 && (ringSizeElements.forEach((element) => {
            element.dataset.ringSize === HackWrapper.getCookie('ringSize') && (element.checked = true);
        }));
    }
});

/* Ring Size */
if (HackWrapper.getElement('.clairspdp-option-item.clairspdp-more-sizes')) {
    let ringSizeElement = HackWrapper.getElement('.clairspdp-option-item.clairspdp-more-sizes');
    var ringOriginalText = ringSizeElement.textContent, changeText = "Hide More Sizes";
    ringSizeElement.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        ringSizeElement.textContent = (ringSizeElement.textContent === ringOriginalText) ? changeText : ringOriginalText;
        
        /* if (HackWrapper.getElement('.clairspdp-option-item.clairspdp-option-item-ring.hidden[data-is-hidden="true"]') == null) {
            const targetOffset = HackWrapper.getElement('.clairspdp-option-group').getBoundingClientRect().top;
            window.scrollTo({ top: targetOffset, behavior: 'smooth' });   
        } */
        HackWrapper.getElements('.clairspdp-option-item.clairspdp-option-item-ring[data-is-hidden="true"]').forEach(i => i.classList.toggle('hidden'));
    });
}

if (HackWrapper.getElements('.clairspdp-option-item.clairspdp-option-item-ring input[name="ring-size"]')?.length > 0) {
    HackWrapper.getElements('.clairspdp-option-item.clairspdp-option-item-ring input[name="ring-size"]').forEach((element) => {
        element.addEventListener("click", async function (e) {
            const selectedRingSize = this.dataset.ringSize;
            HackWrapper.deleteCookie("ringSize");
            selectedRingSize?.length > 0 && HackWrapper.setCookie("ringSize", selectedRingSize, 2);
        });
    });
}

document.getElementById("setting-product-page-cta-button") && document.getElementById("setting-product-page-cta-button").addEventListener("click", function () {
    const settingProductPageSelectRingSize = HackWrapper.getElement('.clairspdp-option-item.clairspdp-option-item-ring input[name="ring-size"]:checked'), stepsParams = HackWrapper.getUrlParameter("steps") != null ? "&steps=settings" : "";
    if (!HackWrapper.isEmpty(settingProductPageSelectRingSize?.dataset?.ringSize)) {
        HackWrapper.setCookie("ringSize", settingProductPageSelectRingSize?.dataset?.ringSize, 2);
        if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter("stone-stock"))) {
            location.href = `/products/${setting_hdn_prod_handle.value}?stone-stock=${HackWrapper.getUrlParameter("stone-stock")}&review=true${stepsParams}`;
        } else {
            const shapeValue = HackWrapper.getElement('.product-page--filter-value-item input[name="stone-shape"]:checked').dataset.value.trim();
            location.href = `/collections/stones?ring-handle=${setting_hdn_prod_handle.value}&shape=${shapeValue}&review=true${stepsParams}`
        }
    } else {
        alert("Please select the ring size.");
    }
});

const thumbnailImageActiveClass = "active", settingThumbnailImageElements = HackWrapper.getElements('.claird-pdp-actions .claird-pdp-btn.setting-product-page-btn-img-3d-action');
if (!HackWrapper.isEmpty(settingThumbnailImageElements)) {
    settingThumbnailImageElements.forEach(element => {
        element.addEventListener('click', async function(e) {
            const viewType = this?.dataset?.type,
            activeType = this?.dataset?.activeType;

            this.classList.remove(thumbnailImageActiveClass);
            HackWrapper.getElement(`.claird-pdp-btn.setting-product-page-btn-img-3d-action[data-type="${activeType}"]`).classList.add(thumbnailImageActiveClass);
            RING_CREATOR_PDP.loadOnClickForImages(viewType);
        });
    });
}

const reviewImageElements = HackWrapper.getElements('.claird-pdp-actions .claird-pdp-btn.review-product-page-btn-action');
if (!HackWrapper.isEmpty(reviewImageElements)) {
    reviewImageElements.forEach(element => {
        element.addEventListener('click', async function(e) {
            const viewType = this?.dataset?.type,
            activeType = this?.dataset?.activeType;

            this.classList.remove(thumbnailImageActiveClass);
            HackWrapper.getElement(`.claird-pdp-btn.review-product-page-btn-action[data-type="${activeType}"]`).classList.add(thumbnailImageActiveClass);
            
            
            const reviewSettingImage = HackWrapper.getElement('[data-review-setting-image]');
            const reviewStoneImage = HackWrapper.getElement('[data-review-stone-image]');
            reviewSettingImage.style.display = "none";
            reviewStoneImage.style.display = "none";
            if (viewType == "Stone") {
                reviewStoneImage.style.display = "block";
            } else {
                reviewSettingImage.style.display = "block";    
            }
            
        });
    });
}

/* Review Ring Size */
if (HackWrapper.getElement('#clair-stone-view-size')) {
    HackWrapper.getElement('#clair-stone-view-size').addEventListener("click", async function (e) {
        const selectedRingSize = this.dataset.ringSize;
        HackWrapper.deleteCookie("ringSize");
        selectedRingSize?.length > 0 && HackWrapper.setCookie("ringSize", selectedRingSize, 2);
    });
}

if (HackWrapper.getElement("#review-product-page-cta-button")) {
    HackWrapper.getElement("#review-product-page-cta-button").addEventListener("click", async function () {
        let _this = this;
        let productObj = RING_CREATOR_PDP.config.selectStoneProduct;

        _this.setAttribute("disabled", "disabled");
        _this.classList.add("disabled");
        _this.textContent = "Adding item...";

        if (Object.keys(productObj)?.length > 0) {
            var formData = new FormData();
            formData.append("action", "add_product_info");
            formData.append("shop", Shopify.shop);
            formData.append('product_title', productObj?.long_title);
            formData.append('product_price', productObj?.total_sales_price);
            formData.append('stock_id', productObj?.id);
            formData.append('labgrown_stock_num', productObj?.stock_num);
            formData.append('product_img', productObj?.image_url?.length > 0 ? productObj?.image_url : `${shopifyFileURL}/no-image.png`);

            let createProductRes =  await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
            if (createProductRes?.success == true) {
                var groupId = Array.from(Array(30), () => Math.floor(Math.random() * 36).toString(36)).join("");
                var tempGroupId = groupId;

                let items = {
                    'items': [
                        {
                            id: document.getElementById("setting_hdn_prod_var_id").value,
                            quantity: 1,
                            properties: {
                                _groupId: tempGroupId,
                                "Ring Size": HackWrapper.getCookie("ringSize") || (HackWrapper.getElement('#clair-stone-view-size').value || ""),
                                'Ignore Stock ID#': RING_CREATOR_PDP?.config?.selectSettingProduct?.product_sku ?? ""
                            },
                        },
                        {
                            id: createProductRes?.data?.var_id,
                            quantity: 1,
                            properties: {
                                _groupId: tempGroupId,
                                Shape: productObj?.shape,
                                Carat: productObj?.size,
                                Color: productObj?.color,
                                Clarity: productObj?.clarity,
                                "_Stock Number": productObj?.stock_num,
                                "_Vendor Id": productObj?.vendor_id,
                                "_Vendor Name": productObj?.vendor_name
                            },
                        },
                    ]
                };
                $addDiamondToCartTry = 0;
                await RING_CREATOR_PDP.addToCartRing(_this, items);   
            }
        } else {
            _this.removeAttribute("disabled", "disabled");
            _this.classList.remove("disabled");
            _this.textContent = "Add to Bag";
            return;
        }
    });
}

const askYourName = HackWrapper.getElement('#ask_your_name');
const askEmail = HackWrapper.getElement('#ask_email');
const askMobile = HackWrapper.getElement('#ask_mobile');
const askMessage = HackWrapper.getElement('#ask_message');

const askErrYourName = HackWrapper.getElement('#ask-err-your-name');
const askErrEmail = HackWrapper.getElement('#ask-err-email');
const askErrMobile = HackWrapper.getElement('#ask-err-mobile');
const askErrMessage = HackWrapper.getElement('#ask-err-message');

if (HackWrapper.getElement('#ask-a-question-popup-btn')) {
    HackWrapper.getElement('#ask-a-question-popup-btn').addEventListener('click', async function(e) {
        e.preventDefault();
        const _this = this;
        _this.innerText = "Please wait...";
        // _this.disabled = true;

        askErrYourName.innerText = HackWrapper.isEmpty(askYourName.value.trim()) ? HackWrapper.validateField("name", "Name", askYourName.value.trim()) : "";
        askErrEmail.innerText = HackWrapper.isEmpty(askEmail.value.trim()) ? HackWrapper.validateField("email", "Email", askEmail.value.trim()) : "";
        askErrMobile.innerText = HackWrapper.isEmpty(askMobile.value.trim()) ? HackWrapper.validateField("phone", "Mobile", askMobile.value.trim()) : "";
        askErrMessage.innerText = HackWrapper.isEmpty(askMessage.value.trim()) ? HackWrapper.validateField("name", "Message", askMessage.value.trim()) : "";

        if (!HackWrapper.isEmpty(askYourName.value.trim()) && !HackWrapper.isEmpty(askEmail.value.trim()) && !HackWrapper.isEmpty(askMobile.value.trim()) && !HackWrapper.isEmpty(askMessage.value.trim())) {
            try {
                var formData = new FormData();
                formData.append("action", "ask");
                formData.append("shop", Shopify.shop);
                formData.append("name", askYourName.value.trim());
                formData.append("email", askEmail.value.trim());
                formData.append("mobile", askMobile.value.trim());
                formData.append("message", askMessage.value.trim());
                formData.append("mobile_country_code", '+1');

                formData.append("product", document.getElementById("setting_hdn_prod_title").value.trim());
                formData.append("pro_id", document.getElementById("setting_hdn_prod_id").value.trim());
                formData.append("pro_type", "Ring");

                const askProdInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
                if (askProdInfo?.status == "success") {
                    askYourName.value = '';
                    askEmail.value = '';
                    askMobile.value = '';
                    askMessage.value = '';
                    HackWrapper.getElement('.clairpop-overlay').style.display = 'none';
                }

                _this.innerText = "Submit";
                _this.disabled = false;
            } catch (error) {
                console.log({ error });
            }
        } else {
            _this.innerText = "Submit";
            _this.disabled = false;
        }
    });
}

if (HackWrapper.getElement('.clairpop-open-btn')) {
    HackWrapper.getElement('.clairpop-open-btn').addEventListener('click', () => {
        askYourName.value = '';
        askEmail.value = '';
        askMobile.value = '';
        askMessage.value = '';
        HackWrapper.getElement('.clairpop-overlay').style.display = 'flex';
    });   
}

if (HackWrapper.getElement('.clairpop-close')) {
    HackWrapper.getElement('.clairpop-close').addEventListener('click', () => {
        askYourName.value = '';
        askEmail.value = '';
        askMobile.value = '';
        askMessage.value = '';
        HackWrapper.getElement('.clairpop-overlay').style.display = 'none';
    });
}

if (HackWrapper.getElement('.clairpop-overlay')) {
    HackWrapper.getElement('.clairpop-overlay').addEventListener('click', (e) => {
        if (e.target.classList.contains('clairpop-overlay')) {
            HackWrapper.getElement('.clairpop-overlay').style.display = 'none';
        }
    });
}